<template>
  <div class="main">
    <div class="card-box"  v-if="list.length">
      <div class="card-item" :style="tmptypeArr[card.tmpType-1]" v-for="card in list" :key="card.tmpId" @click="openCreate(card)">
        <div class="content">
          <div class="left">
            <div class="title">{{card.tmpName}}</div>
            <span class="tag"  v-for="tag in card.tags" :key="tag">{{tag}}</span>
          </div>
          <div class="right">
            <img class="btn-img" :src="[btnArr[card.tmpType-1]]" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="empty-box">
      <van-empty description="暂无数据" />
    </div>
  </div>
</template>

<script>
import tmpType1 from '@/assets/images/tmptype1.png'
import tmpType2 from '@/assets/images/tmptype2.png'
import tmpType3 from '@/assets/images/tmptype3.png'
import tmpType4 from '@/assets/images/tmptype4.png'
import tmpType5 from '@/assets/images/tmptype5.png'
import btn1 from '@/assets/images/btn1.png'
import btn2 from '@/assets/images/btn2.png'
import btn3 from '@/assets/images/btn3.png'
import btn4 from '@/assets/images/btn4.png'
import btn5 from '@/assets/images/btn5.png'
import loadingMixin from '@/mixins/loading-mixin'
import { mapGetters } from 'vuex'
export default {
  name: 'ActivityTemplates',
  mixins: [loadingMixin],
  data() {
    return {
      list: [],
      btnArr: [btn1,btn2,btn3,btn4,btn5],
      tmptypeArr: [
        {background: `url(${tmpType1})`,backgroundSize: '100% 100%'},
        {background: `url(${tmpType2})`,backgroundSize: '100% 100%'},
        {background: `url(${tmpType3})`,backgroundSize: '100% 100%'},
        {background: `url(${tmpType4})`,backgroundSize: '100% 100%'},
        {background: `url(${tmpType5})`,backgroundSize: '100% 100%'},
      ]
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    })
  },
  methods: {
    getTemplateList() {
      const params = {
        pageNum: 1,
        pageSize: 1000,
        filterData: {
          tmpStatus: 0
        }
      };
      this.showLoading();
      this.$api.activityMgmt.getTemplateList(params)
        .then(({data: {list}}) => {
          this.list = list.map(item => {
            return {
              ...item,
              tags: item.tmpTags && item.tmpTags.split(',') || [],
              tmpType: item.tmpType || '1'
            }
          });
        })
        .finally(_ => {
          this.hideLoading();
        });
    },
    openCreate(card) {
      // let createType = this.allIncludes(card.moduleList)
      let params = {
        path: '/activity/create',
        query: {
          tmpId: card.tmpId,
        }
      }
      if (card.creationMethod == 2) {
        params = {
          path: '/newActivity/create',
          query: {
            tmpId: card.tmpId,
            creationMode: 'new',
            isPreview: 1,
            tmpType: card.tmpType || '1'
          }
        }
      }
      this.$router.push(params)
    },
    allIncludes(tmpArr) {
      let createType = true
      let newTmpArr = [
        'sign-up','picture',
        'image-text-detail',
        'attention','store',
        'lottery','spike',
        'connectPic','question',
        'groupBuying','drawLots',
        'style',
      ]
      for(let i = 0; i<tmpArr.length; i++) {
        if (!newTmpArr.includes(tmpArr[i])) {
          createType = false
          return
        }
      }
      return createType
    }
  },
  created() {
    this.getTemplateList();
  }
}
</script>

<style lang="stylus" scoped>
  .card-box {
    padding: 6px;
    .card-item {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 106px;
      box-sizing: border-box;
      padding: 15px; 
      .content {
        display: flex;
        // width: 250px;
        width: 76%;
        height: 100%;
        .left {
          flex: 1;
          .title {
            font-size: 15px;
            font-weight: 600;
            color: #181818;
            margin-left: 4px;
            margin-bottom: 4px;
          }
          .tag {
            color: #7B7B7B;
            font-size: 12px;
            margin-top: 5px;
            line-height: 16px;
            padding: 0 4px;
            border-right: 1px solid #ccc;
            &:last-child {
              border-right: none;
            }
          }
        }
        .right {
          display: flex;
          align-items: center;
          width: 64px;
          height: 100%;
          margin-left: 26px;
          .btn-img {
            width: 64px;
            height: 33px;
          }
        }
      }
    }
  }
  .empty-box {
    display: flex
    justify-content: center
    align-items: center
    height 100vh
  }
  
</style>